import { Component, createRef, createElement } from 'react';
import { c as _defineProperty, _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["children", "onClickOutside", "styles"];
class ClickOutside extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "container", /*#__PURE__*/createRef());
    _defineProperty(this, "handle", e => {
      if (e.type === 'touchend') this.isTouch = true;
      if (e.type === 'click' && this.isTouch) return;
      const {
        onClickOutside
      } = this.props;
      const el = this.container;
      if (el && !el.current.contains(e.target)) {
        onClickOutside(e);
      }
    });
    this.isTouch = false;
  }
  componentDidMount() {
    document.addEventListener('touchend', this.handle, true);
    document.addEventListener('click', this.handle, true);
    if (this.props.enableOnMouseLeave) {
      document.addEventListener('mouseleave', this.handle, true);
    }
  }
  componentWillUnmount() {
    document.removeEventListener('touchend', this.handle, true);
    document.removeEventListener('click', this.handle, true);
    if (this.props.enableOnMouseLeave) {
      document.removeEventListener('mouseleave', this.handle, true);
    }
  }
  render() {
    const _this$props = this.props,
      {
        children,
        onClickOutside,
        styles
      } = _this$props,
      props = _objectWithoutProperties(_this$props, _excluded);
    return /*#__PURE__*/createElement(Div, _extends({}, props, {
      elRef: this.container
    }, styles.root), children);
  }
}
_defineProperty(ClickOutside, "defaultProps", {
  styles: {}
});

export default ClickOutside;
